// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__KW9FB","rodape__icones":"Rodape_rodape__icones__bLXw3"};